module.exports = __webpack_public_path__ + "media/images/flags/de-e9c4fa27c5edbf3b03f7e1c2d9a6c082.png";